<template>
  <div :class="$style['games-slider']">
    <NuxtErrorBoundary>
      <div
        ref="prev"
        :class="[$style['left-shadow'], $style.shadow]"
      />
      <div
        ref="next"
        :class="[$style['right-shadow'], $style.shadow]"
      />
      <div :class="[$style['swiper-button'], $style['swiper-button-prev']]">
        <IconChevronLeft />
      </div>
      <div :class="[$style['swiper-button'], $style['swiper-button-next']]">
        <IconChevronRight />
      </div>
      <swiper
        :slides-per-view="'auto'"
        :space-between="10"
        :speed="swiperSet.speed"
        :navigation="swiperSet.navigation"
        :modules="swiperSet.modules"
        :loop="true"
        class="mySwiper"
      >
        <swiper-slide
          v-for="(game, index) in gamesArr"
          :key="index"
          :class="$style['swiper-slide']"
        >
          <GameSlide
            :game-name="game.name"
            :game-icon="game.icon"
            :game-class="'slide-game'"
            :game-img="game.img"
            :game-gradient="game.gradient"
            :game-url="game.url"
          />
        </swiper-slide>
      </swiper>
    </NuxtErrorBoundary>
  </div>
</template>

<script setup lang="ts">
import GameSlide from "./GameSlide.vue";
import "swiper/scss";
import { Swiper, SwiperSlide } from "swiper/vue";
import { Navigation } from "swiper";
import type { SwiperOptions } from "swiper";

const { t } = useI18n();
const prev = ref<HTMLElement | null>(null);
const next = ref<HTMLElement | null>(null);

const swiperSet: SwiperOptions = reactive({
  speed: 190,
  navigation: {
    prevEl: prev,
    nextEl: next,
  },
  modules: [Navigation],
});

const gamesArr = computed(() => [
  {
    name: t("mini_games.roulette"),
    players: 50,
    icon: "RouletteIcon",
    img: "/mini_games/roulette.png",
    gradient:
      "radial-gradient(105.57% 148.08% at 107.94% 139.77%, rgba(194, 21, 23, 0.45) 0%, rgba(232, 23, 27, 0.00) 100%)",
    url: "/games/roulette",
  },
  {
    name: t("mini_games.crash"),
    players: 150,
    icon: "CrashIcon",
    img: "/mini_games/crush.png",
    gradient:
      "radial-gradient(94.77% 131.75% at 100% 124.82%, rgba(64, 0, 255, 0.40) 0%, rgba(180, 94, 255, 0.00) 100%)",
    url: "/games/crash",
  },
  {
    name: t("mini_games.ladder"),
    players: 250,
    icon: "LadderIcon",
    img: "/mini_games/ladder.png",
    gradient:
      "radial-gradient(92.79% 124.7% at 100% 109.91%, rgba(33, 85, 255, 0.40) 0%, rgba(30, 75, 255, 0.00) 100%)",
    url: "/games/ladder",
  },
  {
    name: t("mini_games.tower"),
    players: 350,
    icon: "TowerIcon",
    img: "/mini_games/tower.png",
    gradient:
      "radial-gradient(97.52% 136.84% at 107.94% 139.77%, #C28515 0%, rgba(232, 159, 23, 0.00) 100%)",
    url: "/games/tower",
  },
  {
    name: t("mini_games.wheel"),
    players: 450,
    icon: "WheelIcon",
    img: "/mini_games/wheel.png",
    gradient:
      "radial-gradient(105.57% 148.08% at 107.94% 139.77%, rgba(194, 21, 23, 0.45) 0%, rgba(232, 23, 27, 0.00) 100%)",
    url: "/games/wheel",
  },
  {
    name: t("mini_games.roulette"),
    players: 50,
    icon: "RouletteIcon",
    img: "/mini_games/roulette.png",
    gradient:
      "radial-gradient(105.57% 148.08% at 107.94% 139.77%, rgba(194, 21, 23, 0.45) 0%, rgba(232, 23, 27, 0.00) 100%)",
    url: "/games/roulette",
  },
  {
    name: t("mini_games.crash"),
    players: 150,
    icon: "CrashIcon",
    img: "/mini_games/crush.png",
    gradient:
      "radial-gradient(94.77% 131.75% at 100% 124.82%, rgba(64, 0, 255, 0.40) 0%, rgba(180, 94, 255, 0.00) 100%)",
    url: "/games/crash",
  },
  {
    name: t("mini_games.ladder"),
    players: 250,
    icon: "LadderIcon",
    img: "/mini_games/ladder.png",
    gradient:
      "radial-gradient(92.79% 124.7% at 100% 109.91%, rgba(33, 85, 255, 0.40) 0%, rgba(30, 75, 255, 0.00) 100%)",
    url: "/games/ladder",
  },
  {
    name: t("mini_games.tower"),
    players: 350,
    icon: "TowerIcon",
    img: "/mini_games/tower.png",
    gradient:
      "radial-gradient(97.52% 136.84% at 107.94% 139.77%, #C28515 0%, rgba(232, 159, 23, 0.00) 100%)",
    url: "/games/tower",
  },
  {
    name: t("mini_games.wheel"),
    players: 450,
    icon: "WheelIcon",
    img: "/mini_games/wheel.png",
    gradient:
      "radial-gradient(105.57% 148.08% at 107.94% 139.77%, rgba(194, 21, 23, 0.45) 0%, rgba(232, 23, 27, 0.00) 100%)",
    url: "/games/wheel",
  },
]);
</script>

<style lang="scss" module>
.games-slider {
  position: relative;
  margin-top: 48px;
  @media screen and (max-width: 650px) {
    width: 350px;
    margin: auto;
    margin-top: 32px;
  }
  @media screen and (max-width: 375px) {
    width: 100%;
  }
}
.swiper-slide {
  width: 325px;
  @media screen and (max-width: 900px) {
    width: 254px;
  }
  @media screen and (max-width: 600px) {
    width: 160px;
  }
}
.swiper-button {
  position: absolute;
  bottom: 50%;
  transform: translateY(50%);
  width: 48px;
  height: 48px;
  z-index: 10;
  left: unset;
  top: auto;
  border-radius: 14px;
  background: var(--general-transparent-light-2);
  backdrop-filter: blur(2px);
  display: flex;
  justify-content: center;
  align-items: center;
  pointer-events: none;
  svg {
    width: 18px;
    height: 18px;
    fill: var(--general-white);
  }

  &:after {
    content: none;
  }

  @media screen and (max-width: 800px) {
    backdrop-filter: none;
    background: none;
    svg {
      width: 28px;
      height: 28px;
    }
  }

  @media screen and (max-width: 650px) {
    width: 28px;
    height: 28px;
  }
}
.swiper-button-next {
  right: 20px;
  .arrow-right {
    background-image: url("~/assets/right.svg");
  }
  @media screen and (max-width: 834px) {
    right: 0;
  }
}
.swiper-button-prev {
  left: 20px;
  .arrow-left {
    background-image: url("~/assets/left.svg");
  }
  @media screen and (max-width: 834px) {
    left: 0;
  }
}
.shadow {
  position: absolute;
  height: 100%;
  width: 140px;
  z-index: 2;
  cursor: pointer;
  @media screen and (max-width: 800px) {
    pointer-events: none;
  }
  @media screen and (max-width: 650px) {
    width: 75px;
  }
  @media screen and (max-width: 550px) {
    width: 32px;
  }
}
.left-shadow {
  left: 0;
  background: linear-gradient(
    270deg,
    rgba(18, 18, 18, 0) 0%,
    var(--shadow-button-slider) 106.43%
  );
  @media screen and (max-width: 575px) {
    left: -1%;
    background: linear-gradient(
      270deg,
      rgba(18, 18, 18, 0) 0%,
      var(--shadow-button-slider) 100%
    );
  }
}
.right-shadow {
  right: 0;
  background: linear-gradient(
    90deg,
    rgba(18, 18, 18, 0) 0%,
    var(--shadow-button-slider) 100%
  );
  @media screen and (max-width: 575px) {
    right: -1%;
  }
}
</style>
